





import { Component, Prop, Vue } from 'vue-property-decorator';
 import { EVENTS } from '../constants';
import BTBConfig from '@/btb-conf.json';
import { BtbConf } from '@/types/BtbConf';
import languages from '@/../localization/languages.json';
import BaseComponent from './BaseComponent.vue';

interface VideoOptions {
  controls: boolean;
  sources: object[];
  tracks: object[];
}

@Component
export default class VideoWrapper extends BaseComponent {
  @Prop({ default: 'dark' }) backgroundTheme!: string;
  @Prop() src!: string;
  @Prop() vtt!: string;
  @Prop({ default: true }) locksSlide!: boolean;
  @Prop({ default: true }) saveVideoData!: boolean;
  public $refs!: {
    video: Vue
  };
  isInteractive :boolean = true;
  private playerOptions: VideoOptions = {
    controls: true,
    sources: [],
    tracks: []
  };
  onVideoReady(player:any){
    this.$emit('player-ready',player)
  }


  created() {

    if (this.src) {
      this.playerOptions.sources.push({
        type: this.src.indexOf(`.mp4`) >= 1? 'video/mp4' : 'application/x-mpegURL',
        src: this.src
      });
    }
    if (this.vtt) {
      let btbConfig: BtbConf = BTBConfig;
      let srclang = btbConfig.courseInfo.localization;
      let label = srclang ? (languages as any)[srclang].name : undefined;

      this.playerOptions.tracks.push({
        srclang: srclang,
        label: label,
        src: this.vtt,
        kind: 'captions'
      });
    }
    this.$on(EVENTS.COMPLETED, () => {
      this.emitCompleted();
    });
  }
}
